import React from 'react';

const WhyChooseUs: React.FC = () => {
  const features = [
    {
      title: 'Transparent & Ethical',
      description: 'Complete transparency in all our operations and ethical practices in every initiative',
      icon: '🔍'
    },
    {
      title: 'Community-Driven',
      description: 'Our approach is centered around community needs and driven by local participation',
      icon: '🤝'
    },
    {
      title: 'Long-term Commitment',
      description: 'We believe in sustainable change through lasting partnerships and continuous support',
      icon: '🌱'
    },
    {
      title: 'Measurable Impact',
      description: 'Every action is tracked and measured to ensure real, quantifiable social impact',
      icon: '📊'
    }
  ];

  return (
    <section id="why-choose-us" className="py-20 bg-gradient-to-br from-gray-50 to-primary/5">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center mb-10 md:mb-16">
          <h2 className="text-4xl sm:text-4xl md:text-4xl font-bold text-gray-900 mb-6">
            Why <span className="text-primary">Choose Us</span>
          </h2>
          <p className="text-base md:text-xl text-gray-600 max-w-3xl mx-auto">
            We are committed to creating sustainable change through transparent, community-focused initiatives that make a real difference.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group relative bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 overflow-hidden cursor-pointer animate-fade-in-up"
              style={{
                animationDelay: `${index * 0.1}s`
              }}
            >
              {/* Gradient Border Effect */}
              <div className="absolute inset-0 bg-gradient-to-br from-primary/20 to-secondary/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

              {/* Content */}
              <div className="relative p-6 text-center">
                {/* Icon Circle */}
                <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-gradient-to-br from-primary to-secondary flex items-center justify-center transform group-hover:scale-110 transition-transform duration-300">
                  <span className="text-2xl">{feature.icon}</span>
                </div>

                {/* Title */}
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-primary transition-colors duration-300">
                  {feature.title}
                </h3>

                {/* Description */}
                <p className="text-gray-600 text-sm leading-relaxed mb-4">
                  {feature.description}
                </p>

                {/* Hover Line */}
                <div className="h-0.5 w-0 bg-gradient-to-r from-primary to-secondary mx-auto group-hover:w-full transition-all duration-300"></div>
              </div>

              {/* Corner Accent */}
              <div className="absolute top-0 right-0 w-12 h-12 bg-gradient-to-br from-primary to-secondary transform translate-x-6 -translate-y-6 group-hover:translate-x-0 group-hover:translate-y-0 transition-transform duration-500 rounded-full opacity-20"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
